export default __webpack_public_path__ + "static/media/tools.662f58d3.svg";